//@ts-nocheck
export const isOfType = <T>(value: unkown, key: string): value is T =>
  key in (value as T);

export const isKeyInType = <T>(value: T, key: unknown): key is keyof T =>
  (key as keyof T) in value;

export const isArrayOfType = <T>(arr: unknown, key: string): arr is T[] =>
  arr.every((item) => typeof item === 'object' && key in item);

export const isArrayOfStrings = (arr: unknown): arr is string[] =>
  Array.isArray(arr) && arr.every((item) => typeof item === 'string');

export const isArrayOfNumbers = (arr: unknown): arr is number[] =>
  Array.isArray(arr) && arr.every((item) => typeof item === 'number');

export const isStringOrUndefined = (
  dataItemValue: unknown,
): dataItemValue is string | undefined | null => {
  return typeof dataItemValue === 'string' || !dataItemValue;
};

export const isNumberOrUndefined = (
  dataItemValue: unknown,
): dataItemValue is number | undefined | null => {
  return typeof dataItemValue === 'number' || !dataItemValue;
};
